import React from "react";
import { Box } from "@mui/material";

import PreChatHeader from "../ui/PreChatHeader";
import PreChatContainer from "../ui/PreChatContainer";
import Column from "../ui/core/Column";
import ChatInput from "../chat/components/ChatInput";
import { channelsConfig } from "../../config/channels";
import DocumentIcon from "../icons/DocumentIcon";

const DocumentsReview: React.FC = () => {
  return (
    <main className="grow flex flex-row bg-hex-gray-100 h-[calc(100%-6rem)]">
      <Column
        sx={{
          height: "100%",
          width: "100%",
          minWidth: 0,
          minHeight: 0,
          overflow: "hidden",
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            pt: { xs: 1.5, sm: 2 },
            pb: { xs: 1, sm: 1.5 },
            boxSizing: "border-box",
          }}
        >
          <PreChatContainer containerClassName="min-w-0">
            <PreChatHeader
              icon={<DocumentIcon size={28} />}
              iconAlt="Documents Review"
              title="Documents Review"
              description="Upload payer correspondence to review it for issues and missing information."
            />
          </PreChatContainer>
        </Box>

        <ChatInput
          requiredInputs={channelsConfig["documents-review"].requiredInputs}
        />
      </Column>
    </main>
  );
};

export default DocumentsReview;
